<div class="metric-input-form">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  
  <mat-dialog-content>
    <!-- Metric Selection -->
    <div class="form-section">
      <h4>Select Metric</h4>
      <div class="form-row">
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Available Metrics</mat-label>
          <mat-select [(ngModel)]="selectedMetric">
            <mat-option *ngFor="let metric of data.availableMetrics" [value]="metric">
              {{ metric.metricName }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="selectedMetric">{{ selectedMetric.description }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <!-- Unit Selection -->
    <div class="form-section">
      <h4>Unit/Symbol</h4>
      <div class="form-row">
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Unit/Symbol</mat-label>
          <mat-select [(ngModel)]="unit">
            <mat-option *ngFor="let unitOption of unitOptions" [value]="unitOption.value">
              {{ unitOption.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Color Settings -->
    <div class="form-section">
      <h4>Text Color</h4>
      <div class="form-row">
        <mat-form-field class="color-input" appearance="outline">
          <mat-label>Text Color</mat-label>
          <input matInput type="color" [(ngModel)]="defaultColor">
        </mat-form-field>
      </div>
    </div>

    <!-- Preview -->
    <div class="form-section" *ngIf="selectedMetric">
      <h4>Preview</h4>
      <div class="metric-preview">
        <div class="preview-value" [style.color]="defaultColor">
          {{ getPreviewValue() }}
        </div>
        <div style="font-size: 12px; color: #666;">
          Metric: {{ selectedMetric.metricName }}
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSave()"
      [disabled]="!isValidInput()">
      Add Metric
    </button>
  </mat-dialog-actions>
</div>